import { useSelector } from "react-redux";

const CartUserDetails = () => {
  const OrgId = useSelector((state) => state.auth.org_id);
    return (
      <div className="">
          <iframe src={`https://iiplwork.retool.com/embedded/public/ce08f392-fd65-4fb5-9b07-0d085b471a4f`}
          className="iframe-style"></iframe>
      </div>
  
    )
  };
  
  export default CartUserDetails;
  